<template>
    <div>
        <div style="display: flex;flex-direction: row">
            <div>
                <canvas id="msg"></canvas>
            </div>
            <div v-if="imgUrl">
                <img :src="imgUrl" style="width: 150px" @click="handleGetCert">
            </div>
            <div v-else>
                <div class="el-icon-refresh"  style="font-size: 50px;height: 150px;line-height: 150px;" @click="handleGetCert"></div>
            </div>
        </div>
        <div style="text-align: right">
            <el-button @click="handlePrint()">打印签收单</el-button>
            <el-button @click="handleDelivery()">确认交货</el-button>
        </div>
        <el-dialog
                title="签收单"
                :visible.sync="dialogVisible"
                width="950px"
                :before-close="handleClose"
                append-to-body
        >
            <Dialog_Signature v-if="dialogVisible"></Dialog_Signature>
        </el-dialog>
    </div>
</template>

<script>
    import store from '@/store'
    import Dialog_Signature from './Dialog_SellSignature'
    import QRCode from 'qrcode'
    export default {
        name: "Dialog_LeaseDelivery",
        data() {
            return {
                QRCodeMsg:'234',
                dialogVisible:false,
                imgUrl:''
            };
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.QRCodeMsg='https://web.xuezhi.app/#/warehouse/upload/'+this.$store.state.modal.data.invoiceId+'/1'
            this.handleGetCert();
        },
        mounted(){
            var msg= document.getElementById('msg')
            // 将获取到的数据（val）画到msg（canvas）上
            QRCode.toCanvas(msg, this.QRCodeMsg, function (error) {
            })
        },
        components: {
            'Dialog_Signature': Dialog_Signature,
        },
        methods: {
            handleGetCert(){
                this.$axios.get(store.state.server + '/getCert?invoiceId='+this.$store.state.modal.data.invoiceId+'&type=1')
                    .then((response) => {
                        if (response.data.code == '0000') {
                            if(response.data.content.result.image){
                                this.imgUrl=response.data.content.result.image.url
                            }

                        }
                    }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });
                    this.$Win.closeModal();
                })
            },
            handlePrint(){
                this.dialogVisible=true
                //this.$Win.openModal('Dialog_Signature', 700, 400, '打印签收单',{'invoiceId':this.$store.state.modal.data.invoiceId});
            },
            handleDelivery(){
                this.$axios.get(store.state.server + '/sureCommit?invoiceId='+this.$store.state.modal.data.invoiceId).then((response) => {
                    if (response.data.code == '0000') {
                        this.$message({
                            type: 'success',
                            message: '交货成功!'
                        });
                        this.$Win.closeModal()
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            }
        }
    }
</script>

<style lang="scss">
    #msg{
        width:150px !important;
        height:150px !important;
    }
</style>